import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useCurrentOrgId } from "../auth";
import { queryConfigs } from "@/lib/queryClient";

export interface LeadSource {
  id: string;
  org_id: string;
  name: string;
  label: string;
  is_active: boolean;
  sort_order: number;
  created_at: string;
}

export const useLeadSources = (activeOnly = true) => {
  const { orgId } = useCurrentOrgId();

  return useQuery({
    ...queryConfigs.structural,
    queryKey: ["lead-sources", orgId, activeOnly],
    queryFn: async (): Promise<LeadSource[]> => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const client = supabase as any;
      let query = client
        .from("lead_sources")
        .select("*")
        .eq("org_id", orgId)
        .order("sort_order");

      if (activeOnly) {
        query = query.eq("is_active", true);
      }

      const { data, error } = await query;
      if (error) throw error;
      return (data ?? []) as LeadSource[];
    },
    enabled: !!orgId,
  });
};
